import { useEffect } from "react";
import { usePartnerWorkingFolderStore } from "../../../../stores/Cac/Partner/partnerWorkingFolder";
import { useParams } from "react-router-dom";
import { useTokenContext } from "../../../../context/tokenContext";
import {
  createWorkingFolder,
  getPartnerAssociated,
} from "../../../../services/Api/customerService";
import { IUserManagerMission } from "../../../../interfaces/user";
import { useUtilsStore } from "../../../../stores/Utils/selects";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";
import SelectManager from "../Utils/SelectManager";
import SelectServiceMission from "../Utils/SelectServiceMission";
import SelectYear from "../Utils/SelectYear";
import { verifyEmail } from "../../../../services/Utils/functionService";
import { usePartnerMissionStore } from "../../../../stores/Cac/Partner/partnerMission";

const CreateWorkingFolder = () => {
  const {
    choiceModalWF,
    setChoiceModalWF,
    collabsAssignedToClient,
    setCollabsAssignedToClient,
    checkboxValuesCollabs,
    setCheckboxValuesCollabs,
    checkboxValuesClients,
    setCheckboxValuesClients,
    dataWorkingFolder,
    resetWorkingFolder,
    mails,
    setMails,
    email,
    setEmail,
  } = usePartnerWorkingFolderStore();
  const { idCustomer } = useParams();
  const { userId } = useTokenContext();
  const { resetSelects, selectedManager } = useUtilsStore();
  const { updateMission, setUpdateMission } = usePartnerMissionStore();

  const handleResetAll = () => {
    resetWorkingFolder();
    resetSelects();
    setChoiceModalWF("");
    setCheckboxValuesClients({});
    setMails([]);
    setCheckboxValuesCollabs({});
  };

  // Function to get collaborateurs assign to a client
  useEffect(() => {
    if (idCustomer)
      // This is for collabs
      getPartnerAssociated(Number(idCustomer))
        .then((data) => {
          // Supprimer le manager de la liste
          const filteredData = data.filter(
            (collab: any) => collab.id !== selectedManager
          );

          const mappedData: { [key: number]: IUserManagerMission } = {};

          filteredData.forEach((assignUser: IUserManagerMission) => {
            mappedData[assignUser.id] = assignUser;
          });

          if (choiceModalWF === "create") {
            const checkboxValues: { [key: number]: boolean } = {};
            Object.values(mappedData).forEach(
              (assignUser: IUserManagerMission) => {
                if (assignUser.id === userId) {
                  checkboxValues[assignUser.id] = true;
                } else {
                  checkboxValues[assignUser.id] = false;
                }
              }
            );

            setCollabsAssignedToClient(Object.values(mappedData));
            setCheckboxValuesCollabs(checkboxValues);
          }
        })
        .catch(() => showToastError("Une erreur s'est produite"));
      }, [idCustomer, choiceModalWF]);

  const handleCheckboxChangeCollabs = (value: number, checked: boolean) => {
    setCheckboxValuesCollabs({ ...checkboxValuesCollabs, [value]: checked });
  };

  const handleCheckboxChangeClients = (value: string, checked: boolean) => {
    setCheckboxValuesClients((prevValues) => ({
      ...prevValues,
      [value]: checked,
    }));
  };

  const handleCreateOrUpdateMission = async () => {
    if (dataWorkingFolder.dateExercice === null) {
      showToastError("Veuillez renseigner une date d'exercice");
      return;
    } else if (dataWorkingFolder.categoryId === 0) {
      showToastError("Veuillez renseigner une catégorie de mission");
      return;
    } else if (dataWorkingFolder.managerId === 0) {
      showToastError("Veuillez sélectionner un responsable");
      return;
    } else if ( Object.entries(checkboxValuesClients).length === 0) {
      showToastError("Veuillez ajouter un client");
      return;
    }

    try {
      if (idCustomer !== "0") {
        let dataForSend;
        dataForSend = {
          idCategoryMission: dataWorkingFolder.categoryId,
          exercice: String(dataWorkingFolder.dateExercice),
          idManager: dataWorkingFolder.managerId,
          operatorIds: Object.entries(checkboxValuesCollabs)
            .filter(([_, value]) => value)
            .map(([key]) => Number(key))
            .join(","),
          emails: Object.entries(checkboxValuesClients)
            .filter(([_, value]) => value)
            .map(([key]) => key)
            .join(","),
        };

        let workingFolderResponse;

        // Création de la mission avec les utilisateurs assignés par le serveur
        workingFolderResponse = await createWorkingFolder(
          Number(idCustomer),
          dataForSend
        );

        if (workingFolderResponse) {
          handleResetAll();
          showToastSuccess("Le dossier client a bien été créé");
          setUpdateMission(!updateMission);
        } else {
          showToastError("Une erreur est survenue");
        }
      }
    } catch (error) {
      handleResetAll();
      showToastError("Une erreur est survenue");
    }
  };

  const handleCreateNewClient = () => {
    if (verifyEmail(email)) {
      mails.push(email);
      setEmail("");
      setCheckboxValuesClients((prevValues) => {
        const updatedValues = { ...prevValues };
        mails.forEach((user) => {
          if (!(user in updatedValues)) {
            updatedValues[user] = true;
          }
        });
        return updatedValues;
      });
    }
  };

  return (
    choiceModalWF !== "" && (
      <>
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden p-2 font-BarlowCondensed outline-hidden focus:outline-hidden sm:p-5">
          <div className="relative m-auto h-full max-h-[calc(100dvh-1rem)] w-full max-w-5xl sm:max-h-[90dvh]">
            {/* Content */}
            <div className="relative flex h-full w-full flex-col overflow-hidden rounded-2xl border-0 bg-gradient-to-br from-slate-50 to-blue-50 shadow-2xl outline-hidden focus:outline-hidden">
              {/* Body */}
              <div className="flex min-h-0 w-full flex-1 flex-col items-center justify-start overflow-y-auto p-2 sm:p-3">
                {/* Configuration du dossier de travail */}
                <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-3 mb-3">
                  <h4 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    <svg className="w-4 h-4 text-yellow-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    Configuration du dossier de travail
                  </h4>
                  <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-3">
                    <SelectManager />
                    <SelectServiceMission />
                    <SelectYear />
                  </div>
                </div>

                {/* Gestion des utilisateurs */}
                <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-3 mb-3">
                  <h4 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    <svg className="w-4 h-4 text-yellow-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    Gestion des utilisateurs
                  </h4>
                  
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    {/* Collaborateurs affectés */}
                    <div className="bg-gray-50 rounded-xl p-3 border border-gray-200">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-blue-100 rounded-lg">
                          <svg className="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        </div>
                        <h5 className="font-semibold text-gray-700 text-sm">Collaborateurs affectés</h5>
                      </div>
                      <div className="w-full bg-white border border-gray-200 rounded-lg m-auto h-32 overflow-y-auto shadow-sm">
                        {collabsAssignedToClient?.map((user) => (
                          <div
                            key={user?.id}
                            className="flex items-center p-2 border-b border-gray-100 hover:bg-blue-50 transition-colors duration-150"
                          >
                            <input
                              type="checkbox"
                              checked={checkboxValuesCollabs[user?.id] || false}
                              onChange={() => {
                                handleCheckboxChangeCollabs(
                                  user?.id,
                                  !checkboxValuesCollabs[user?.id]
                                );
                              }}
                              className="mr-2 w-3.5 h-3.5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                            />
                            <label className="text-xs text-gray-700 cursor-pointer">
                              {user?.firstName === ""
                                ? user?.eMail
                                : `${user?.firstName} ${user?.lastName}`}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Création client */}
                    <div className="bg-gray-50 rounded-xl p-3 border border-gray-200">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-green-100 rounded-lg">
                          <svg className="w-3.5 h-3.5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                          </svg>
                        </div>
                        <h5 className="font-semibold text-gray-700 text-sm">Création client</h5>
                      </div>

                      <div className="w-full bg-white border border-gray-200 rounded-lg p-3 h-32 flex flex-col justify-between">
                        <div className="flex flex-col gap-2">
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">Email</label>
                            <input
                              type="email"
                              className="w-full px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-150 text-sm"
                              minLength={10}
                              maxLength={200}
                              value={email}
                              placeholder="exemple@email.com"
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <button
                          onClick={() => handleCreateNewClient()}
                          className="w-full bg-green-600 hover:bg-green-700 cursor-pointer text-white font-medium rounded-lg px-3 py-1.5 text-xs transition-colors duration-150 flex items-center justify-center gap-1"
                        >
                          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                          Ajouter
                        </button>
                      </div>
                    </div>

                    {/* Clients affectés */}
                    <div className="bg-gray-50 rounded-xl p-3 border border-gray-200">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-purple-100 rounded-lg">
                          <svg className="w-3.5 h-3.5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                          </svg>
                        </div>
                        <h5 className="font-semibold text-gray-700 text-sm">Clients affectés</h5>
                      </div>

                      <div className="w-full bg-white border border-gray-200 rounded-lg h-32 overflow-y-auto shadow-sm">
                        {mails?.map((user, index) => (
                          <div
                            key={index}
                            className="flex items-center p-2 border-b border-gray-100 hover:bg-purple-50 transition-colors duration-150"
                          >
                            <input
                              type="checkbox"
                              checked={checkboxValuesClients[user] ?? true}
                              onChange={() => {
                                handleCheckboxChangeClients(
                                  user,
                                  !checkboxValuesClients[user]
                                );
                              }}
                              className="mr-2 w-3.5 h-3.5 text-purple-600 bg-gray-100 border-gray-300 rounded focus:ring-purple-500 focus:ring-2"
                            />
                            <div className="flex flex-col">
                              <span className="text-xs font-medium text-gray-700">{user}</span>
                              <span className="text-xs text-gray-500 italic">Client ajouté</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="flex flex-shrink-0 items-center justify-end gap-3 rounded-b-2xl border-t border-solid border-gray-200 bg-white p-3">
                <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-500 transition-all duration-200 hover:bg-red-500 hover:text-white sm:flex-none"
                  type="button"
                  onClick={() => handleResetAll()}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Annuler
                </button>
                <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:bg-green-700 hover:shadow-xl sm:flex-none sm:hover:scale-105"
                  type="button"
                  onClick={handleCreateOrUpdateMission}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  Créer le dossier
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )
  );
};

export default CreateWorkingFolder;
